// share function system fallback
// it can be a browser feature flag, so share button (share-area) is always display:none until "shareTest" is allowed
import {SlAlert} from '@shoelace-style/shoelace/shoelace';

export class Share {
    private readonly viewRoot: HTMLElement;
    private readonly SAVE_MICRO_ACTION = '/tarif/save_microconversion';
    private readonly SAVE_MICRO_TYP = 'sharelink';

    constructor(viewRoot: HTMLElement) {
        this.viewRoot = viewRoot;
        this.initShareEvents();
    }

    private initShareEvents(): void {
        const shareButtons = this.viewRoot.querySelectorAll<HTMLElement>('[data-share]');

        if (shareButtons.length === 0) {
            return;
        }
        shareButtons.forEach((shareButton: HTMLElement) => {
            const shareLink = shareButton.dataset.sharelink as string;
            const shareText = shareButton.dataset.sharetext as string;
            const shareTitle = shareButton.dataset.sharetitle as string;
            const defaultText = shareButton.dataset.defaulttext as string;

            shareButton.addEventListener('click', async (e: MouseEvent) => {
                e.preventDefault();

                this.saveMircoconversion(shareButton);

                if (navigator.share) {
                    navigator.share({
                        title: shareTitle,
                        text: shareText,
                        url: shareLink,
                    });
                } else {
                    navigator.clipboard.writeText(shareLink);
                    this.showNotifyMessage(defaultText);
                }
            });
        });
    }

    private saveMircoconversion(element: HTMLElement): void {
        const formData = new FormData();
        formData.append('vtid', element.dataset.vtid ?? '');
        formData.append('typ', this.SAVE_MICRO_TYP);

        fetch(this.SAVE_MICRO_ACTION, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            cache: 'default',
            credentials: 'same-origin',
        });
    }

    private showNotifyMessage(message: string): void {
        let alertMsg = document.createElement('sl-alert') as SlAlert;
        alertMsg.duration = 3000;
        alertMsg.innerHTML = `<sl-icon name="check-circle-fill" slot="icon" class="white"></sl-icon>${message}`;
        alertMsg.className = 'merkliste-alert';
        document.body.append(alertMsg);
        alertMsg.show();
    }
}
